function formatDate(dateString, format) {
  const date = new Date(dateString);

  const pad = (num) => (num < 10 ? "0" : "") + num;

  const monthNames = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];

  return format.replace(/(YYYY|MM|DD|hh|mm|ss|CMM)/g, (match) => {
    switch (match) {
      case "YYYY":
        return date.getFullYear();
      case "CMM":
        return monthNames[date.getMonth()];
      case "MM":
        return pad(date.getMonth() + 1);
      case "DD":
        return pad(date.getDate());
      case "hh":
        return pad(date.getHours());
      case "mm":
        return pad(date.getMinutes());
      case "ss":
        return pad(date.getSeconds());
      default:
        return match;
    }
  });
}

export default formatDate;
